import { Normalization } from './normalization'

// Sanctum's personal-access-token plaintext shape: `<id>|<secret>`. The secret's
// charset is not ours to assume -- sanctum.token_prefix prepends an arbitrary
// configured string (here `mealz_local_`), so this checks structure only.
const SANCTUM_TOKEN_PATTERN = /^\d+\|\S+$/

export const isValidSanctumToken = (value: string): boolean =>
  Normalization.checkPattern(value, SANCTUM_TOKEN_PATTERN)
